<template>
  <div class="bigbox">
    <!-- @scroll="scrollEvent" -->
    <div class="container"  id="contain">
      <div class="top" id="">
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="订单状态：" prop="fbillstatus" class="tinp">
            <el-select v-model="OrderType" placeholder="请选择订单状态" clearable class="myselect" >
              <el-option v-for="item in fbillstatulist" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
         <!--  <el-form-item label="订单编号：" prop="cinspaceid" class="tinp">
            <el-input v-model="vbillcode" placeholder="请输入订单编号" suffix-icon="el-icon-search" clearable @change="onParamChange"></el-input>
          </el-form-item> -->
        <!--   <el-form-item label="商品名称：" prop="modifiedtime" class="tinp">
            <el-input v-model="productName" placeholder="请输入商品名称" suffix-icon="el-icon-search" clearable @change="onParamChange"></el-input>
          </el-form-item> -->
          <el-button type="primary" class="" size="small" icon="el-icon-search" @click="onParamChange"  v-loading.fullscreen.lock="fullscreenLoading">搜索</el-button>
        </el-form>
      </div>
      <div class="order-list-table" v-if="count >= 1">
           <!-- 采购单数据 -->
        <table class="downtablelist" style="min-width: 1243px !important" v-for="(data,index) in goodsList" v-if="OrderType=='5'">
          <tr>
            <th :id="data.vbillcode" style="width:33px;font-color:#56B8AA;background-color:#fff;position:relative" @click="showlist(data,index)">
              <i class="iconfont icon-jiantou_yemian_xiangshang jiantouxia" v-bind:class="{'jiantoushang':data.listshow =='N'}" style="color: #56B8AA;font-size: 22px;font-weight: 100;"></i>
            </th>
            <th colspan="9" class="thbox">
              <span class="toptitle fl" style="margin-left: 20px;">采购单号：{{data.vbillcode}}</span>
              <span class="toptitle fl" >请购日期：{{data.dmakedate}}</span>
              <span class="toptitle fl">审核人：{{data.approvername}}</span>
              <span class="toptitle fr">采购购总数：{{data.ntotalastnum}}</span> 
              <!-- <span class="toptitle fr">合计：{{data.ntotalorigmny|currency('￥')}}</span> -->
              <span class="toptitle fr">采购人：{{data.cemployeename}}</span>
              <span v-if="data.modifiername!='' && data.modifiername!=null" class="toptitle fr">最后修改人：{{data.modifiername}}</span>
            </th>
          </tr>
          <tr class="first noimg" v-show="data.listshow =='Y'">
            <td style="width:33px" bgcolor="#EFF0F4"></td> 
            <td style="width:240px">商品名称</td>
            <td style="width:150px">商品编码</td>
            <td style="width:80px">采购数量</td>
            <td style="width:80px">入库数量</td>
            <!-- <td style="width:80px">单价</td> -->
            <td style="width:214px">规格</td>
            <td style="width:214px">型号</td> 
            <td style="width:70px;text-align: center;padding-right: 20px !important" class="lastbut">
              操作
            </td>
          </tr>      
          <tr v-for="(item,index2) in data.productList" class="first noimg"   v-show="data.listshow =='Y'">
            <td style="width:33px" bgcolor="#EFF0F4"></td> 
            <td style="width:240px">{{ item.vvendinventoryname }}</td>
            <td style="width:150px">{{ item.vvendinventorycode }}</td>
            <td style="width:80px">x{{ item.nnum }}</td>
            <td style="width:80px">x{{ item.naccumstorenum }}</td>
            <!-- <td style="width:80px">{{ item.nqtorigtaxprice|currency('￥') }}</td> -->
            <td style="width:214px">规格:{{ item.wlspec }}</td>
            <td style="width:214px">型号:{{ item.wltype }}</td> 
            <td class="lastbut" style="width:70px;text-align: center;padding-right: 20px !important">
              <el-button type="primary" size="small" class="" @click="handleSubmit('2',index)" v-if="index2==0">查看明细</el-button>
            </td>
          </tr>
        </table>
        <!-- 请购单数据 -->
        <table class="downtablelist" style="min-width: 1243px !important" v-for="(data,index) in goodsList" v-if="OrderType!='5'">
          <tr>
            <th :id="data.vbillcode" style="width:33px;font-color:#56B8AA;background-color:#fff;position:relative" @click="showlist(data,index)">
              <i class="iconfont icon-jiantou_yemian_xiangshang jiantouxia" v-bind:class="{'jiantoushang':data.listshow =='N'}" style="color: #56B8AA;font-size: 22px;font-weight: 100;"></i>
            </th>
            <th colspan="7" class="thbox">
              <span class="toptitle fl" style="margin-left: 20px;">请购单号：{{data.vbillcode}}</span>
              <span class="toptitle fl" >请购日期：{{data.dmakedate}}</span>
              <span v-if="OrderType!='0'" class="toptitle fl">审核人：{{data.approvername}}</span>
              <span class="toptitle fr">请购总数：{{data.ntotalastnum}}</span> 
              <!-- <span class="toptitle fr">合计：{{data.ntotaltaxmny|currency('￥')}}</span> -->
              <span class="toptitle fr">请购人：{{data.prabilPeople}}</span>
              <span v-if="data.modifiername!='' && data.modifiername!=null" class="toptitle fr">最后修改人：{{data.modifiername}}</span>
            </th>
          </tr>
          <tr class="first noimg" v-show="data.listshow =='N'">
            <td style="width:33px" bgcolor="#EFF0F4"></td> 
            <td style="width:240px">商品名称</td>
            <td style="width:150px">商品编码</td>
            <td style="width:80px">数量</td>
            <!-- <td style="width:80px">单价</td> -->
            <td style="width:214px">规格</td>
            <td style="width:214px">型号</td>
           <!--  <td v-if="OrderType!='0'" style="width:70px;text-align: center;padding-right: 20px !important" class="lastbut">
              操作
            </td> -->
          </tr>      
          <tr v-for="(item,index2) in data.productList" class="first noimg" v-show="data.listshow =='N'">
            <td style="width:33px" bgcolor="#EFF0F4"></td>
            <td style="width:240px">{{ item.productName }}</td>
            <td style="width:150px">{{ item.productCode }}</td>
            <td style="width:80px">x{{ item.nnum }}</td>
            <!-- <td style="width:80px">{{ item.ntaxprice|currency('￥') }}</td> -->
            <td style="width:214px">规格:{{ item.wlspec }}</td>
            <td style="width:214px">型号:{{ item.wltype }}</td>
           <!--  <td  v-if="OrderType!='0'" class="lastbut" style="width:70px;text-align: center;padding-right: 20px !important">
              <el-button type="primary" size="small" class="" @click="handleSubmit('1',index)" v-if="index2==0">查看明细</el-button>
            </td> -->
          </tr>
        </table> 
      </div>
      <div class="msgNone" v-else style="text-align: center;font-size: 15px;color: #333;margin-top: 20px">
        暂无数据
       </div>
     <!-- fenye start -->
        <div class="block" style="text-align: center;margin:20px auto ">
            <span>
            <el-pagination class="fenye" @size-change="handleSizeChange" @current-change="handleCurrentChange"  background
              :current-page="page"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="count">
            </el-pagination>
            </span>
        </div>
    </div>
    <!-- <Modal :mdShow='mdshow'></Modal> -->
    <div class="model" v-show="mdShow">
      <div class="content" id="details">
        <div class="title">
          <span class="fl">订单明细</span>
          <span class="fr" @click="closemodel(0.1)"><i class="iconfont icon-guanbi"></i></span>
        </div>
        <div class="ordertop">
        </div>
        <div class="tablebox shou" style="margin-bottom:30px;">
          <div style="width:745px;margin: 0 auto"> 
              <table style="border: 1px solid #56B8AA;width:745px">
                <tr>
                  <th style="width:105px" v-for="head in tableHeads">{{ head.label }}</th>
                </tr>
              </table>
                   
              <div style="overflow-y: auto;overflow-x: hidden;width:745px;height:262px">
                 <table style="width:745px">
                  <tr v-for="(item,index) in tableData" :key="item.period">
                    <td v-for="head in tableHeads" style="border: 1px solid #56B8AA; width:105px">
                      <span>{{item[head.key]}}</span>
                    </td>
                  </tr>
                </table>
              </div>
          
          </div>
        </div>
      </div>
    </div> 
    <el-button type="info" v-show="showTop" icon="el-icon-arrow-up" circle id="to-top-btn" style="position:fixed;right:16px;bottom:20px;" @click="toTop"></el-button>
    <!-- model end -->
    <div class="" v-show="fullscreenLoading"></div>
  <!-- 弹窗 start --> 
      <MessageModel types="提示信息" :msg="msg" :msgShow="msgShow" :flag="modelFlag" :butmsg="butmsg" :butflag = "butflag" @modelmsg="returnMsg"></MessageModel>  
  </div>
</template>
<style>
    
    
</style>
<script>
import { currency } from '../../utils/currency'
import axios from 'axios'
var self =this;
export default {
    data() {
      var validatorNum = (rule, value, callback) => {
              if (value === '') {
                  callback(new Error('请输入退货数量'));
              }
              if (!Number.isInteger(value)) {
                callback(new Error('请输入数字值'));
              } else {
                if (value < 1) {
                  callback(new Error('数量不能小于1'));
                } else {
                  callback();
                }
              }
      };
      var validatorDan = (rule, value, callback) => {
              if (value === '') {
                  callback(new Error('请输入退货单号'));
              }else {
                  callback();
              }
      };
      var validatorReason = (rule, value, callback) => {
              if (value === '') {
                  callback(new Error('至少选择一个原因'));
              }else {
                  callback();
              }
      };
      return {
        flag:false,
        msgShow:false,
        modelFlag:false,
        modelFlag2:false,
        butflag:true,
        butflag2:true,
        msg:'', 
        butmsg:'确认', 
        butmsg2:'确认', 
        methodName:'', 
        utilpath:'',
        mingxiindex:'',
        id:'',
        index1:'',
        height: 0,
        mdShow: false,
        fullscreenLoading: false,
        tuimsgShow: false,
        productName: '',
        OrderType:3,
        page: 1,
        pagesize: 10,
        count:0,
        showTop:false,//显示回到顶部按钮
        step:0,//移动距离
        loading: false,
        vbillcode: '',
        fbillstatus: '',
        tuilist: {
          vbillcode: '',
          store_code: '',
          store_name: '',
          materialcode:'',
          materialname: '',
            returnNum:'',
            returnOrder:'',
            Reason:'',
            returnmsg:''
        },
        rules: {
          returnNum: [
            { validator: validatorNum, trigger: 'blur' },
          ],
          returnOrder: [
            { validator: validatorDan, trigger: 'blur' },
          ],
          Reason: [
            { validator: validatorReason, trigger: 'blur' }
          ]
        },
        ReasonList:[{
            label: '原因一',
            value: 0
          },
          {
            label: '原因二',
            value: 1
          },
          {
            label: '原因三',
            value: 2
          }
        ],
        tableHeads: [
                  {
                      label: '收货仓库',
                      key: 'repertoryname'
                  },
                  {
                      label: '收货货位',
                      key: 'positionname'
                  },
                  {
                      label: '物料名称',
                      key: 'vvendinventoryname'
                  },
                  {
                      label: '请购数量',
                      key: 'nznum'
                  },
                  {
                      label: '采购数量',
                      key: 'nnum'
                  },
                  {
                      label: '发货数量',
                      key: 'nqnum'
                  },
                  {
                      label: '入库数量',
                      key: 'nqtorigtaxprice'
                  },
                  // {
                  //     label: '收货人',
                  //     key: 'receivename'
                  // },
                  {
                      label: '备注',
                      key: 'memo'
                  }
              ],      
         
        fbillstatulist: [
            // {
            //   label: '已完成',
            //   value: 5
            // }, 
            {
              label: '审批过程中',
              value: 2
            },
             {
              label: '已通过',
              value: 3
            },
            {
              label: '未通过',
              value: 4
            }
            
        ],
        goodsList: [],
        tableData: [],
        orderList: [],     
        model1: '',
      }
    },
    watch: {
     
    },
    mounted() {
      this.InterfacePath = window.localStorage.getItem("InterfacePath");
      this.utilpath = this.axios.defaults.baseURL;
      this.init(); 
    },
    filters: {
      currency: currency
    },
    computed: {
        
      // ...mapState({
      //   mdShow:state=>state.modelstate.modelshow1,
      //   tuimsgShow:state=>state.modelstate.modelshow2
      // }),
      // show11:this.$store.getters.modelshow1,
      // mdShow(){
      //   console.log("实时计算"+JSON.stringify(this.$store.state.modelstate));
      //   console.log("实时计算"+JSON.stringify(this.$store.getters.modelshow1));
      //     return this.$store.getters.modelshow1;
      // },
      // tuimsgShow(){
      //    console.log("实时计算"+JSON.stringify(this.$store.state.modelstate));
      //    console.log("实时计算"+JSON.stringify(this.$store.state.modelstate));
      //      return this.$store.getters.modelshow2;
      // },
    },
    destroyed (){
        sessionStorage.removeItem("mdShow");
        sessionStorage.removeItem("tuimsgShow");
        sessionStorage.removeItem("tuilist");
        sessionStorage.removeItem("tableData");
        sessionStorage.removeItem("productlist");
        sessionStorage.removeItem("buyType");
        sessionStorage.removeItem("vbillcode");
        sessionStorage.removeItem("productName");
    },
    methods: {
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.pagesize = val;
        this.page=1; 
      this.getList();
        // console.log(this.pagesize);
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.page = val;
        // console.log(this.page);
        this.getList();
      },
     returnMsg(flag){ 
      this.modelFlag = false;
      if(flag){
             // console.log("---进来了！！！----"+this.methodName);
            if(this.methodName =='---'){
                var reqparams={
                  storecode:this.users.storecode,
                  productCode:this.productCode
                }
                // console.log("---参数！！！----"+JSON.stringify(this.reqparams)); 
                this.$http.post(this.utilpath+'/delettePrabillB',reqparams,{emulateJSON:true,_timeout:600}).then((res)=>{ 
                    if(res.data.status == '0'){
                        
                    }else{
                      this.modelFlag = true;
                      this.msgShow = true;
                      this.methodName = 'message';
                      this.msg = res.data.message;
                      this.butflag =false;
                      this.butmsg='知道了';
                      //  this.$alert('门店请购单信息删除失败', '失败信息', {
                      //   confirmButtonText: '确定'
                      // });
                    }
                }, (err) => {
                  this.modelFlag = true;
                  this.msgShow = false;
                  this.methodName = 'message';
                  this.msg = '获取接口失败'+err;
                  this.butflag =false;
                  this.butmsg='知道了'; 
                })
            }
      }else{
        this.$message({
          showClose:true,
          message:'已取消',
          type:'succcess'
        })
      }
    },  
       //显示隐藏表格
      showlist(item,index){ 
          this.goodsList[index].listshow = item.listshow=='Y'?'N':'Y'; 
                this.id = item.vbillcode;
                this.toTop();  
      },
      scrollEvent(e){
          // this.scrollToTop();
          this.showTop = e.srcElement.scrollTop>800?true:false;
          //滚动的像素+容器的高度>可滚动的总高度-20像素
          // console.log("触发滚动事件");
          if(e.srcElement.scrollTop+e.srcElement.offsetHeight>e.srcElement.scrollHeight-20 && this.loading){ 
            this.getList(true);    //加载更多
          }
      },
      toTop() {
        var idmsg =''
        if(this.id !=''){
            idmsg = this.id;
            // console.log("-=-=-=-=-=-=--=-:"+idmsg);
        }else{
            idmsg = 'contain';
            // console.log("-=-=-=-=-=-=--=-:"+idmsg);
        }
          //参数i表示间隔的幅度大小，以此来控制速度
          var dis = (document.getElementById(idmsg).scrollTop)/8
          this.step += dis;
          document.getElementById(idmsg).scrollTop-=dis;
          var scroll = document.getElementById(idmsg).scrollTop;
          if (scroll>0) {
              // console.log("回到顶部循环内"+ document.getElementById(idmsg).scrollTop);
              // this.step+=dis
              var c=setTimeout(()=>this.toTop(),16);
          }else {
              clearTimeout(c);
          }
      }, 
      col(msg) {//实时计算列合并数
         if (msg.fbillstatus == '5') {
            return 8; 
        } else { return 7; } 
      },
      returnGoods(index, item) {//打开退货模型
        
        sessionStorage.setItem("tuimsgShow",true);
        this.tuimsgShow = true;
        this.tuilist.vbillcode = this.goodsList[index].vbillcode;
        this.tuilist.store_code = this.goodsList[index].store_code;
        this.tuilist.store_name = this.goodsList[index].store_name;
        this.tuilist.materialcode = item.materialcode;
        this.tuilist.materialname = item.materialname;
        sessionStorage.removeItem("tuilist");
        sessionStorage.setItem("tuilist",JSON.stringify(this.tuilist));
      },
      tuishow(data) {//判断是否显示去退货
        if (data.fbillstatus == '5') { 
              return true; 
        } else { 
              return false; 
        }
      },
      yituishow(data) {//判断是否显示去退货
        if (data.fbillstatus == '3') { 
              return true; 
        } else { 
              return false; 
        }
      },
       //获取数据
      getList() { 
        this.fullscreenLoading = true;          
        var reqParams = {
          storecode:this.users.storecode,//门店编码
          productName: this.productName,//名
          forderstatus: this.OrderType,//单据状态
          vbillcode: this.vbillcode,//订单编号
          pageNum: this.page,//当前页
          pageSize: this.pagesize//页面数据条数
        }
        var methodname='';
        methodname='/selectPoPraybill'
        if(this.OrderType == '5'){
          methodname='/selectPoOrderInfo';
        }; 
        //获取数据接口 
        this.$http.post(this.utilpath+methodname,reqParams,{emulateJSON:true,_timeout:600}).then((res) => {
        // this.$http.post("/ktnapi"+methodname,reqParams,{emulateJSON:true}).then((res) => {
        //this.$post(methodname,reqParams,{emulateJSON:true}).then((res) => {
        // this.$http.post(this.InterfacePath+methodname,reqParams,{emulateJSON:true}).then((res) => { 
              if(res.data.status == '0'){    
                  this.fullscreenLoading = false;          
                  this.goodsList=res.data.resultList;
                  this.count = res.data.countNum;
              }else if(res.data.status == '-1'){
                this.fullscreenLoading = false;
                this.goodsList=[];
              } else if(res.data.status == '9'){
                this.fullscreenLoading =false;
                this.$router.push({path:'/ui/login',query:{msg:9}});
              } else{
                this.fullscreenLoading = false;
                this.modelFlag = true;
                this.msgShow = true;
                this.methodName = 'message';
                this.msg = res.data.message;
                this.butflag =false;
                this.butmsg='知道了'; 
              }
          }, (err) => {
              this.fullscreenLoading = false;
              this.modelFlag = true;
              this.msgShow = false;
              this.methodName = 'message';
              this.msg = '连接查询总部请购单接口失败';
              this.butflag =false;
              this.butmsg='知道了'; 
          });
      },
      init() {
        this.widthdata = document.documentElement.clientWidth - 254; 
        var goods = JSON.parse(sessionStorage.getItem("productlist"));
        this.users = JSON.parse(window.localStorage.getItem("userInfo"));
        if(goods == null){ 
          // this.getList();
        }else{
          this.fullscreenLoading = false; 
          this.goodsList = goods;
          this.OrderType =this.fbillstatulist[sessionStorage.getItem("OrderType")].value;
          this.vbillcode = sessionStorage.getItem("vbillcode");
          this.productName = sessionStorage.getItem("productName");
        }
          var Show1 = sessionStorage.getItem("mdShow");
          var Show2 = sessionStorage.getItem("tuimsgShow");
          var tabledata = JSON.parse(sessionStorage.getItem("tableData"));
          var tuidata = JSON.parse(sessionStorage.getItem("tuilist"));
          if(Show1 == null){
              this.shouShow= false;
          }else{
              this.shouShow=Show1;
              this.tableData=tabledata;
          } 
           if(Show2 == null){
            this.tuimsgShow= false;
          }else{
              this.tuimsgShow=Show2;
              this.tuilist=tuidata;
          }
      },
      handleSubmit(mes,index) {//查看明细
        this.tableData = [];
        var num = this.goodsList[index].productList.length;
        this.goodsList[index].productList.forEach((item) => {
          this.tableData.push(item);
        });
        if (num < 5) {
          this.height = (50 + (42 * num));
        } else {
          this.height = (50 + (42 * 5));
        }
        sessionStorage.removeItem("tableData");
        sessionStorage.setItem("tableData",JSON.stringify(this.tableData));
        // console.log("打印session的tabledate"+this.tableData);
        sessionStorage.setItem("mdShow",true);
        this.mdShow =true;
        // this.$store.dispatch('modelshow1',true);
         // this.$store.commit('modelshow1',false);
        // this.mdShow = true;
      },
      closemodel(num,e) {
        if(num == 0.1){
          sessionStorage.removeItem("mdShow");
          this.mdShow = false;
          // this.$store.dispatch('modelshow1',false);
           // this.$store.commit('modelshow1',false);
        }else if(num == 1.1){
           sessionStorage.removeItem("tuimsgShow");
           this.tuimsgShow = false;
          // this.$store.dispatch('modelshow2',false);
           // this.$store.commit('modelshow2',false);
        }else if (num == 0) {
          var sp = document.getElementById("details");
          if(sp){
              if(!sp.contains(e.target)){            //这句是说如果我们点击到了id为myPanel以外的区域
                  sessionStorage.removeItem("mdShow");
                  this.mdShow = false;
                  // this.$store.dispatch('modelshow1',false);
                   // this.$store.commit('modelshow1',false);
              }
          }
        } else {
          var sp = document.getElementById("tui");
          if(sp){
              if(!sp.contains(e.target)){            //这句是说如果我们点击到了id为myPanel以外的区域
                  sessionStorage.removeItem("tuimsgShow");
                  this.tuimsgShow = false;
                  // this.$store.dispatch('modelshow2',false);
                  // this.$store.commit('modelshow2',false);
              }
          }
        }
      },
      onParamChange() {
        sessionStorage.setItem("OrderType",this.OrderType);
        sessionStorage.setItem("vbillcode",this.vbillcode);
        sessionStorage.setItem("productName",this.productName);
        this.page = 1;
        this.getList();
        document.getElementById("contain").scrollTop=0;
        sessionStorage.removeItem("productlist");
        sessionStorage.setItem("productlist",JSON.stringify(this.goodsList));
      },
      // 单选点击事件
      choose(item, data, index) {
        item.checked = item.checked == "1" ? '0' : '1';
        data.productList.forEach((item) => {
          if (item.checked != '1') {
            data.allchecked = false;
            return;
          }
        });
        var money = 0;
        data.productList.forEach((item2) => {
          if (item2.checked == '1') {
            money += parseFloat(item2.ntaxmny);
          };
        });
        this.goodsList[index].ntotaltaxmny = money; 
      },
      // 全选点击事件
      toggleCheckAll(data, index) {
        var flag = data.allchecked == false ? true : false;
        data.allchecked = flag
        data.productList.forEach((item) => {
          item.checked = flag ? '1' : '0';
        });
        var money = 0;
        data.productList.forEach((item2) => {
          if (item2.checked == '1') {
            money += parseFloat(item2.ntaxmny);
          };
        });
        this.goodsList[index].ntotaltaxmny = money;
      }
    }
}

</script>



// WEBPACK FOOTER //
// src/views/order/yitijiao.vue